module.exports = __webpack_public_path__ + "media/images/questionnaire_examples/concept_testing_product-180f29d666afbf5d917eb4b5a15a4bb7.png";